import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import PocketBase from 'pocketbase'; // Assuming PocketBase is available or imported similarly

const pb = new PocketBase(process.env.REACT_APP_PB_URL);
pb.autoCancellation(false);

const FeedbackPage = () => {
  const { ticketId } = useParams();
  const [ticket, setTicket] = useState(null);
  const [loading, setLoading] = useState(true);
  const [feedback, setFeedback] = useState({
    supportRating: 0,
    speedRating: 0,
    recommendation: '',
  });
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchTicket = async () => {
      try {
        if (!ticketId) {
          setError('Ticket ID not provided.');
          setLoading(false);
          return;
        }
        // Fetch ticket details from PocketBase using ticketId
        const ticketRecord = await pb.collection('Tickets').getOne(ticketId);
        // Optional: Add validation here to check if the ticket is in a state to receive feedback
        setTicket(ticketRecord);
        setLoading(false);
      } catch (err) {
        console.error('Error fetching ticket:', err);
        setError('Could not load ticket details.' + (err.message ? ': ' + err.message : ''));
        setLoading(false);
      }
    };

    fetchTicket();
  }, [ticketId]);

  const handleStarClick = (type, rating) => {
    setFeedback({ ...feedback, [type]: rating });
  };

  const handleRecommendationChange = (event) => {
    setFeedback({ ...feedback, recommendation: event.target.value });
  };

  const handleSubmitFeedback = async () => {
    if (!ticketId) {
      setError('Ticket ID not provided.');
      return;
    }
    try {
      // Update the ticket in PocketBase with the feedback JSON
      const feedbackData = {
        feedback: JSON.stringify(feedback), // Use the correct field name 'feedback'
      };
      await pb.collection('Tickets').update(ticketId, feedbackData);
      setSubmitted(true);
    } catch (err) {
      console.error('Error submitting feedback:', err);
      setError('Failed to submit feedback. Please try again.' + (err.message ? ': ' + err.message : ''));
    }
  };

  if (loading) {
    return <div>Loading ticket...</div>;
  }

  if (error) {
    return <div>Error: {error}</div>;
  }

  if (!ticket) {
    return <div>Invalid ticket ID or ticket not found.</div>;
  }

  if (submitted) {
    return <div>Thank you for your feedback!</div>;
  }

  return (
    <div style={{ padding: '20px', maxWidth: '600px', margin: '0 auto' }}>
      <h2>How did we do?</h2>

      <div>
        <p>1. Were you happy with the support?</p>
        {[1, 2, 3, 4, 5].map((star) => (
          <span
            key={star}
            style={{ cursor: 'pointer', color: star <= feedback.supportRating ? 'gold' : 'gray' }}
            onClick={() => handleStarClick('supportRating', star)}
          >
            ★
          </span>
        ))}
      </div>

      <div style={{ marginTop: '20px' }}>
        <p>2. Were you happy with the speed of the support personnel getting back to you?</p>
        {[1, 2, 3, 4, 5].map((star) => (
          <span
            key={star}
            style={{ cursor: 'pointer', color: star <= feedback.speedRating ? 'gold' : 'gray' }}
            onClick={() => handleStarClick('speedRating', star)}
          >
            ★
          </span>
        ))}
      </div>

      <div style={{ marginTop: '20px' }}>
        <p>3. Is there anything else that you would recommend?</p>
        <textarea
          style={{ width: '100%', minHeight: '100px', padding: '10px' }}
          placeholder="Your feedback is always welcome..."
          value={feedback.recommendation}
          onChange={handleRecommendationChange}
        ></textarea>
      </div>

      <div style={{ marginTop: '30px' }}>
        <button
          style={{
            backgroundColor: '#0d1a4d', // Dark blue button color from image
            color: 'white',
            padding: '10px 20px',
            border: 'none',
            borderRadius: '5px',
            cursor: 'pointer',
            fontSize: '16px',
          }}
          onClick={handleSubmitFeedback}
        >
          Submit Feedback
        </button>
      </div>
    </div>
  );
};

export default FeedbackPage; 